import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import useRedirect from "../../hooks/useRedirect";
import { useData } from "../../context/RedirectContext";
import logo from "./Tbd-Logo.webp";

const RedirectLoader = () => {
  const { p_id, s_id } = useParams();
  const [timeOutIdRef] = useRedirect(p_id, s_id, 1000);
  const { data } = useData();
  const navigate = useNavigate();
  console.log("Data from ContextAPI", data);

  return (
    <>
      <div className="bg-gray-100 gap-10 p-10 flex flex-col justify-center items-center w-full h-[80vh]">
        <div className="img"></div>
        <div className="text-sm font-bold text-center text-gray-800 text sm:text-md md:text-lg ">
          <h2 className="mb-4">That's it! Your search ends here</h2>
          <p>
            Shop at{" "}
            {data.isLoading
              ? "Flipshope"
              : data?.storeData?.data[0]?.store_name}{" "}
            and apply the most suitable coupon from the cart on your favorite
            product.
          </p>
        </div>
        <div className="flex items-center justify-start gap-10 icons sm:gap-20">
          <div className="imgBox min-w-28 max-w-60 ">
            <img src={logo} alt="" />
          </div>
          <div className="imgBox min-w-28 max-w-60 ">
            <img
              className="w-full overflow-hidden"
              src={data?.storeData?.data[0]?.img_url || "#"}
              alt=""
            />
          </div>
        </div>
        <div className="flex loader ">
          <div className="text-xl font-bold text-gray-500 uppercase animate-pulse sm:text-2xl md:text-3xl ">
            Redirecting...
          </div>
        </div>
        <p className="font-medium text-center text-gray-700">
          Click{" "}
          <a
            href={data?.redirectURLData?.link || "#"}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              clearTimeout(timeOutIdRef.current);
              navigate("/");
            }}
            className="text-lg font-bold text-blue-600 underline"
          >
            here
          </a>{" "}
          if you are not redirected automatically.
        </p>
      </div>
    </>
  );
};

export default RedirectLoader;
